import React from "react";
import { FaUserMd, FaBuilding, FaFlask, FaAward } from "react-icons/fa";
import "./Stats.css";

const statsData = [
  { icon: <FaUserMd />, number: "30+", label: "Години искуство" },
  { icon: <FaBuilding />, number: "10.000+", label: "Задоволни пациенти" },
  { icon: <FaFlask />, number: "1.000+", label: "Лабораториски анализи" },
  { icon: <FaAward />, number: "24/7", label: "Поддршка" },
];


function Stats() {
  return (
    <section className="stats">
      <div className="container stats-container">
        {statsData.map((item, index) => (
          <div key={index} className="stat-item">
            <div className="stat-icon">{item.icon}</div>
            <h3 className="stat-number">{item.number}</h3>
            <p>{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Stats;